import React from 'react';
import { useConnect } from 'app/views/hooks/useConnect';
export const useScreenRect = (width, height, contentWidth, contentHeight) => {
    const [screenRect, setScreenRect] = React.useState(null);
    const stateProps = useConnect(state => {
        const { viewport } = state;
        return {
            zoom: viewport.zoom,
            canvasRect: viewport.canvas,
            designRect: viewport.design,
            padding: viewport.padding,
        };
    });
    const { designRect, canvasRect, zoom, padding } = stateProps;
    React.useEffect(() => {
        if (designRect) {
            const miniMapScale = width / contentWidth;
            const screenToMiniMapScale = miniMapScale / zoom;
            const rect = {
                x: -(designRect.x - padding.x) * screenToMiniMapScale,
                y: -(designRect.y - padding.y) * screenToMiniMapScale,
                width: canvasRect.width * screenToMiniMapScale,
                height: canvasRect.height * screenToMiniMapScale,
            };
            setScreenRect(rect);
        }
        else {
            setScreenRect(null);
        }
    }, [
        width,
        height,
        contentWidth,
        contentHeight,
        designRect,
        canvasRect,
        zoom,
        padding,
        setScreenRect,
    ]);
    return [screenRect];
};
